import { Button, FormLabel, LinearProgress, OptionType, SearchableSelect, TagSelect } from "shared";
import { IOrgBankDetail, templatesService, IBankDetail } from "entities/template";
import React, { useEffect, useMemo, useState } from "react";
import { useComponentsTranslations } from "../../../../../lib/i18n";
import { joinBankOptionLabelParts } from "../../../../../lib/utils/bank_detail_option_label";
import styles from "./bank_details_modal.module.scss";
import { useParams } from "react-router-dom";

interface IBankDetailsModalProps {
    close: () => void;
    values: number[];
    defaultValue?: number;
    companyName: string;
    onSave: (value: IBankDetail) => void;
}

export const BankDetailsModal: React.FC<IBankDetailsModalProps> = React.memo(({
                                                                                  close,
                                                                                  values,
                                                                                  defaultValue,
                                                                                  companyName,
                                                                                  onSave
                                                                              }) => {
    const t = useComponentsTranslations();
    const [bankDetailsList, setBankDetailsList] = useState<IOrgBankDetail[]>([]);
    const [bankDetailsValue, setBankDetailsValue] = useState<number[]>(values);
    const [bankDefaultValue, setBankDefaultValue] = useState<number | undefined>(defaultValue);
    const [loading, setLoading] = useState<boolean>(false);
    const { extUserId } = useParams();

    useEffect(() => {
        loadBankDetails();
    }, [])

    useEffect(() => {
        loadBankDetails();
    }, [values])

    const constructOptions = useMemo(() => {
        return bankDetailsList.map((details) => {
            return {
                value: details.id.toString(),
                label: joinBankOptionLabelParts(
                    details.ya_bank_name,
                    details.ya_payment_account,
                    details.ya_corr_account
                ),
            };
        });
    }, [bankDetailsList]);

    const onChangeBankDetails = (value: string[]) => {
        const bankIds = value.map(idStr => parseInt(idStr))
        setBankDetailsValue(bankIds);
        if (bankDefaultValue && !bankIds.includes(bankDefaultValue)) {
            setBankDefaultValue(undefined);
        }
    }

    const onSaveBtnClick = () => {
        onSave({
            item: companyName,
            bankNameDefaultValue: bankDefaultValue,
            bankNameWhiteList: bankDetailsValue
        })
        close();
    }

    const loadBankDetails = () => {
        setLoading(true);
        templatesService.getOrganizationDetails(companyName, extUserId).then((organization) => {
            setLoading(false)
            if (organization.ya_bank_details && organization.ya_bank_details.length > 0) {
                setBankDetailsList(organization.ya_bank_details);
            }
        })
    }

    return <div className={styles.container}>
        {loading && <LinearProgress/>}
        {!loading && <>
            <TagSelect value={bankDetailsValue.map(id => id.toString())}
                       options={constructOptions}
                       placeholder={t("bank")}
                       onChange={onChangeBankDetails}/>
            <FormLabel title={t("defaultValue")}>
                <SearchableSelect
                    options={constructOptions.filter((o) => bankDetailsValue.map(v => v.toString()).includes(o.value))}
                    placeholder={t("no")}
                    optionValue={bankDefaultValue ? constructOptions.find((o) => o.value === bankDefaultValue.toString()) as OptionType : undefined}
                    onChange={(val) => {
                        setBankDefaultValue((val ? parseInt(val as string) : undefined))
                    }}
                    isMulti={false}
                    hideClearIcon={false}
                    isSearchable={true}
                />
            </FormLabel>
            <div className={styles.buttonGroup}>
                <Button className={styles.button}
                        view="legal"
                        onClick={onSaveBtnClick}>
                    {t("save")}
                </Button>
            </div>
        </>}
    </div>
});
